<!--


<style>
    .breadcrumb {
        background-color: var(--colorImgs8);
        color: #ffffff;
        font-weight: bold;
        padding:8px; 
        border:1px solid #dddddd; 
        border-radius: 7px;
    }

    .clickable {
        background-color: var(--colorDan);
        cursor: pointer;
    }
</style>

<div [hidden]="!selectedSummaryRecord" style="margin-bottom:20px;">
    <span><span class="breadcrumb clickable" (click)="selectedSummaryRecord = undefined">All Transactions</span> &nbsp;&nbsp; </span>
    <span class="breadcrumb" [hidden]="!selectedSummaryRecord || !selectedSummaryRecord.month">{{uiHelper.getMonthAbbrFromNumber(selectedSummaryRecord?.month)}} / {{selectedSummaryRecord?.year}}</span>
</div> 
-->

<app-filterable-table
  #transactionsSummaryTable
  [tableView]="summaryTableView"
></app-filterable-table>
